import type { FunctionComponent } from "react";

import {
  type NumberFormatValues,
  NumericFormat,
  type NumericFormatProps,
} from "react-number-format";

type InputPropsType = {
  [key: string]: string | number | boolean | undefined;
};

interface NumericInputProps extends NumericFormatProps {
  maxQuantity?: number;
  inputProps?: InputPropsType;
}

export const NumericInput: FunctionComponent<NumericInputProps> = ({
  thousandSeparator = ",",
  thousandsGroupStyle = "thousand",
  isAllowed,
  maxQuantity,
  inputProps,
  ...rest
}) => {
  const handleMaxQuantity = (
    values: NumberFormatValues,
  ): boolean | undefined => {
    if (!maxQuantity) {
      return true;
    }

    const { floatValue } = values;
    return (floatValue ?? 0) <= maxQuantity;
  };

  const handleIsAllowed = (values: NumberFormatValues): boolean | undefined => {
    return isAllowed?.(values);
  };

  return NumericFormat({
    thousandSeparator: thousandSeparator,
    thousandsGroupStyle: thousandsGroupStyle,
    isAllowed: (values) => {
      return (
        (handleIsAllowed(values) ?? true) && (handleMaxQuantity(values) ?? true)
      );
    },
    ...inputProps,
    ...rest,
  });
};
